import styled from "styled-components";
import { Button, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import FlexBox from "../../components/FlexBox";
import axios from "axios";
import { PillarChart } from "./PillarChart";
import { UserContext } from "../../context/UserContext";
import Pill from "../../components/Pill";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Icon from "../../components/Icon";
import PreviewModal from "../Portfolio/PreviewModal";
import CMKLLogoImage from "../../assets/cmkl.png";
import a1ceLogoImage from "../../assets/logo.png";

export const MasteryLevelPage = () => {
  const CustomLayout = styled.div`
    padding: 12px;
    height: 80vh; /* Ensure a defined height for the container */
  `;

  const sofData = [
    { subject: "SOF-101", A: 1 },
    { subject: "SOF-201", A: 4 },
    { subject: "SOF-301", A: 0 },
    { subject: "SOF-401", A: 4 },
    { subject: "SOF-501", A: 3 },
    { subject: "SOF-601", A: 4 },
    { subject: "SOF-701", A: 3 },
  ];

  const [coreData, setCoreData] = useState([]);
  const [nonCoreData, setNonCoreData] = useState([]);
  const [isEmptyData, setIsEmptyData] = useState(false);
  const [pdfBlob, setPdfBlob] = useState<Blob | null>(null);

  const currentUser = useContext(UserContext).user;

  useEffect(() => {
    getMasterySummary();
  }, []);

  const getMasterySummary = () => {
    axios
      .get(
        `/student/mastery_summary?student_id=${currentUser.id}&program_name=${currentUser?.programs?.[0]?.program_name}`
      )
      .then((res: any) => {
        if (res?.data?.mastery_summary?.length > 0) {
          const core: any = [];
          const nonCore: any = [];
          res.data.mastery_summary.map((v: any) => {
            if (v.is_core) {
              core.push(v);
            } else nonCore.push(v);
          });
          setCoreData(core);
          setNonCoreData(nonCore);
        } else {
          setIsEmptyData(true);
        }
      })
      .catch(() => {});
  };

  const [selectedOption, setSelectedOption] = useState("all");

  // Export chart to PDF
  const exportChartToPDF = () => {
    const chartContainer = document.querySelector(".chart-container");

    if (!chartContainer) {
      alert("Radar chart not found!");
      return;
    }

    // Clone the chart container
    const clonedChart = chartContainer.cloneNode(true) as HTMLElement;
    clonedChart.style.position = "fixed";
    clonedChart.style.top = "-9999px"; // Push it off-screen
    clonedChart.style.left = "-9999px";

    document.body.appendChild(clonedChart);

    // Apply the black text color for labels and text
    const labels = clonedChart.querySelectorAll("text");
    labels.forEach((label: any) => {
      label.style.fill = "black"; // Change text color to black
    });

    html2canvas(clonedChart, { backgroundColor: null })
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("portrait", "mm", "a4"); // Set to portrait orientation

        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;

        // Add the left logo to the top-left corner
        const logoWidth = 25; // Adjust the width of the logo
        const logoHeight = 10; // Adjust the height of the logo
        pdf.addImage(CMKLLogoImage, "PNG", 10, 10, logoWidth, logoHeight);

        // Add the right logo to the top-right corner
        pdf.addImage(a1ceLogoImage, "PNG", pdfWidth - 22, 10, 10, 10);

        const ratio = Math.min(
          pdfWidth / canvasWidth,
          pdfHeight / canvasHeight
        );

        const imgWidth = canvasWidth * ratio;
        const imgHeight = canvasHeight * ratio;

        const x = (pdfWidth - imgWidth) / 2;

        let yOffset = 20; // Initial vertical offset for the first chart

        // Add title and first table on the first available page
        pdf.setFontSize(16);
        pdf.text("Mastery Level", 84, yOffset);

        yOffset += 20; // Adjust the yOffset for the next text line

        pdf.setFontSize(10);
        // Left-aligned text
        pdf.text(
          `Name: ${currentUser.first_name + " " + currentUser.last_name}`,
          14,
          yOffset
        );
        yOffset += 7; // Increment yOffset after each line

        const formattedDate = new Date().toLocaleString("en-GB", {
          month: "short", // "Jan"
          day: "2-digit", // "17"
          year: "numeric", // "2025"
          hour: "2-digit", // "13"
          minute: "2-digit", // "08"
        });

        pdf.text(`Date: ${formattedDate}`, 14, yOffset);
        yOffset += 7;

        yOffset += 20; // Provide some space before the chart

        // Add the radar chart image to the PDF
        pdf.addImage(imgData, "PNG", x, yOffset, imgWidth, imgHeight);

        const pdfOutput = pdf.output("blob");
        setPdfBlob(pdfOutput);
        // pdf.save(
        //   `${currentUser.first_name.toLowerCase()}_${currentUser.last_name.toLowerCase()}_mastery.pdf`
        // );
      })
      .catch((err) => {
        console.error("Failed to export chart:", err);
      })
      .finally(() => {
        document.body.removeChild(clonedChart);
      });
  };

  return (
    <CustomLayout>
      {pdfBlob && (
        <PreviewModal
          setOpen={() => setPdfBlob(null)}
          isOpen={pdfBlob !== null}
          pdfBlob={pdfBlob}
        />
      )}
      <FlexBox>
        {/* <Radio
          checked={selectedOption === "all"}
          onChange={() => setSelectedOption("all")}
          value="a"
          name="radio-buttons"
          inputProps={{ "aria-label": "A" }}
          sx={{
            color: "white",
          }}
        />
        All Pillars */}
        {/* <Radio
          checked={selectedOption === "sof"}
          value="b"
          name="radio-buttons"
          inputProps={{ "aria-label": "B" }}
          sx={{
            marginLeft: 5,
            color: "white",
            opacity: 0.5,
            cursor: "default",
          }}
        />
        <span style={{ opacity: 0.5, cursor: "disabled" }}>SOF PIllars</span> */}
        <FlexBox justify="end" style={{ width: "100%" }}>
          <Button
            style={{
              // padding:10,
              boxShadow: "0 2px 4px #00000063",
              padding: "10px 50px",
              borderRadius: 5,
              color: "white",
              background:
                "linear-gradient(90deg, rgb(176, 52, 52) 0%, #f00 118.29%)",
              position: "fixed",
              top: 90,
              right: 20,
              zIndex: 100,
            }}
            onClick={exportChartToPDF}
          >
            <Icon size={3.5} name="download-alt" style={{ paddingRight: 10 }} />
            Export to PDF
          </Button>
        </FlexBox>{" "}
      </FlexBox>

      <div
        className="chart-container"
        style={{ display: "flex", height: "70vh" }}
      >
        <h3
          style={{
            position: "fixed",
            zIndex: 999999,
            left: "50%",
            top: 26,
            transform: "translateX(-50%)",
          }}
        >
          My Mastery
        </h3>

        {!isEmptyData ? (
          selectedOption === "all" ? (
            <>
              <PillarChart
                data={coreData}
                stroke={"#007BFF"}
                fill={"#4e8aff"}
                label="Core Pillars"
              />
              <PillarChart
                data={nonCoreData}
                stroke={"rgb(162 137 0)"}
                fill={"#ffe364"}
                label="Non-Core Pillars"
              />
            </>
          ) : (
            <PillarChart
              data={sofData}
              stroke={"#007BFF"}
              fill={"#4e8aff"}
              label="SOF Pillars"
            />
          )
        ) : (
          <FlexBox
            justify="center"
            alignItems="center"
            style={{ width: "100%" }}
          >
            <span
              style={{
                background: "#ff002447",
                fontSize: "x-large",
                padding: 20,
                borderRadius: 5,
              }}
            >
              No Record Found!
            </span>
          </FlexBox>
        )}
      </div>
    </CustomLayout>
  );
};
